import { api } from './api';

export interface BoardFigure {
  accountCode: string;
  scenario: string;
  total: number;
}

export interface BoardPackResult {
  workspaceId: string;
  audience: 'board' | 'cfo' | 'investor';
  period: { start: string; end: string };
  sections: { heading: string; body: string }[];
  /** Top-account figures the prose is grounded in (rendered as a table). */
  figures?: { currency: string; topAccounts: BoardFigure[] };
  /** USD cost — customers see this; model name is operator-side only. */
  costUsd: number;
  /** IDs of fp_facts the writer was shown — drives the citation byline. */
  citedFactIds: string[];
  /** Sign-off block resolved from the latest board_pack approval. */
  signers?: Signer[];
}

export interface Signer {
  name: string;
  role: string;
  approvedAt: string | null;
}

export const boardPackApi = {
  async write(workspaceId: string, body: { audience: 'board' | 'cfo' | 'investor'; periodStart: string; periodEnd: string }): Promise<BoardPackResult> {
    const r = await api.post<BoardPackResult>(`/api/workspaces/${workspaceId}/board-pack`, body);
    return r.data;
  },
  /**
   * Streams the rendered A4 PDF (with the hanko sign-off block) back to
   * the browser. We download as a Blob so the caller can hand it to a
   * native save-as dialog without the response touching DOM.
   */
  async downloadPdf(
    workspaceId: string,
    body: { audience: 'board' | 'cfo' | 'investor'; periodStart: string; periodEnd: string; signers?: Signer[] },
  ): Promise<Blob> {
    const r = await api.post(`/api/workspaces/${workspaceId}/board-pack/pdf`, body, { responseType: 'blob' });
    return r.data as Blob;
  },
};
